module.exports = __webpack_public_path__ + "img/report_stethoscope.91f2d243.svg";